export enum LeaderboardOptionTypeEnum {
    Plant = 'Plant',
    Owner = 'Owner',
    Optimiser = 'Optimiser',
}

export enum LeaderboardMarketPriceOptionEnum {
    WeightedAverageDayAheadPrice = 'WeightedAverageDayAheadPrice',
    EpexDayAheadPrice = 'EpexDayAheadPrice',
    NordpoolDayAheadPrice = 'NordpoolDayAheadPrice',
    IntradayPrice = 'IntradayPrice',
    BestPrice = 'BestPrice',
}

export enum LeaderboardGasPriceOptionEnum {
    DayAheadForward = 'DayAheadForward',
    DayAheadSpot = 'DayAheadSpot',
    WithinDaySpot = 'WithinDaySpot',
    CheapestPrice = 'CheapestPrice',
}

export enum BMBreakdownOptionEnum {
    BidOfferSplit = 'BidOfferSplit',
    SystemEnergySplit = 'SystemEnergySplit',
}

export enum AncillaryOptionEnum {
    FrequencyAndReserve = 'FrequencyAndReserve',
    ByProduct = 'ByProduct',
    ByDirection = 'ByDirection',
}

export enum NonDeliverySplitOutOptionEnum {
    Ignore = 'Ignore',
    Show = 'Show',
    Absorb = 'Absorb',
}
